import * as React from 'react';

import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {Tooltip} from '@spaced-out/ui-design-system/lib/components/Tooltip';

import useLabelTranslation from 'src/hooks/useLabelTranslation';
import type {RowType} from 'src/types/byod';

import {getWidgetLimitTooltipBody} from 'src/components/analytics-genesis/byod/utils/widget-limit-tooltip';

import {useCanvasContext} from './canvas-context';
import layoutCss from './dashboard-builder-canvas-layout.css';


export type TileDividerProps = {
  rowId: string;
  rowType: RowType;
  colIndex: number;
  interactive: boolean;
};

export const TileDivider = React.memo(
  ({rowId, rowType, colIndex, interactive}: TileDividerProps) => {
    const {t} = useLabelTranslation();
    const {onAddWidget, isAtWidgetLimit} = useCanvasContext();

    if (!interactive) {
      return <div className={layoutCss.tileGap} />;
    }

    const tooltipBody = isAtWidgetLimit
      ? getWidgetLimitTooltipBody(t)
      : t('Add_Report', 'Add Report');

    return (
      <div className={layoutCss.tileDivider}>
        <div className={layoutCss.tileDividerLine} />
        <div className={layoutCss.tileDividerActions}>
          <Tooltip body={tooltipBody} placement="top">
            {/* Span wrapper so the Tooltip's hover listeners attach to a
                non-disabled element — see add-row-divider.tsx for the
                rationale. */}
            <span style={{display: 'inline-flex'}}>
              <button
                type="button"
                className={layoutCss.rowDividerBtn}
                aria-label={t('Add_Report', 'Add Report')}
                disabled={isAtWidgetLimit}
                onClick={() => onAddWidget?.({rowId, col: colIndex, rowType})}
              >
                <Icon
                  name="square-poll-vertical"
                  type="solid"
                  size="medium"
                  color={isAtWidgetLimit ? 'disabled' : 'clickable'}
                />
              </button>
            </span>
          </Tooltip>
        </div>
      </div>
    );
  },
);
